import type { DateValue } from "react-aria-components";
import {
  CalendarCell as RACCalendarCell,
  type CalendarCellProps as RACCalendarCellProps,
  CalendarGrid as RACCalendarGrid,
  CalendarGridBody as RACCalendarGridBody,
  type CalendarGridBodyProps as RACCalendarGridBodyProps,
  CalendarGridHeader as RACCalendarGridHeader,
  type CalendarGridHeaderProps as RACCalendarGridHeaderProps,
  type CalendarGridProps as RACCalendarGridProps,
  CalendarHeaderCell as RACCalendarHeaderCell,
  type CalendarHeaderCellProps as RACCalendarHeaderCellProps,
  Heading as RACHeading,
  type HeadingProps as RACHeadingProps,
  RangeCalendar as RACRangeCalendar,
  type RangeCalendarProps as RACRangeCalendarProps,
} from "react-aria-components";

export interface RangeCalendarProps<T extends DateValue> extends RACRangeCalendarProps<T> {}
export interface RangeCalendarGridProps extends RACCalendarGridProps {}
export interface RangeCalendarGridHeaderProps extends RACCalendarGridHeaderProps {}
export interface RangeCalendarGridBodyProps extends RACCalendarGridBodyProps {}
export interface RangeCalendarHeaderCellProps extends RACCalendarHeaderCellProps {}
export interface RangeCalendarCellProps extends RACCalendarCellProps {}
export interface RangeCalendarHeadingProps extends RACHeadingProps {}

export function RangeCalendar<T extends DateValue>(props: RangeCalendarProps<T>) {
  return <RACRangeCalendar {...props} />;
}

export function RangeCalendarGrid(props: RangeCalendarGridProps) {
  return <RACCalendarGrid {...props} />;
}

export function RangeCalendarGridHeader(props: RangeCalendarGridHeaderProps) {
  return <RACCalendarGridHeader {...props} />;
}

export function RangeCalendarGridBody(props: RangeCalendarGridBodyProps) {
  return <RACCalendarGridBody {...props} />;
}

export function RangeCalendarHeaderCell(props: RangeCalendarHeaderCellProps) {
  return <RACCalendarHeaderCell {...props} />;
}

export function RangeCalendarCell(props: RangeCalendarCellProps) {
  return <RACCalendarCell {...props} />;
}

export function RangeCalendarHeading(props: RangeCalendarHeadingProps) {
  return <RACHeading {...props} />;
}
